// @ts-nocheck
import React, { FC, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useGetCartsAll, usePostCartAddProductToCart, usePostCart } from 'api';
import { IPostCartPositionsRequest } from 'api/types';
import { Button, Modal } from 'components/controls';
import { useDispatch, useSelector, reduxActions } from 'store';
import styles from 'theme/components/containers/AddPositionsToCartSelect/AddPositionsToCartSelect.module.scss';
import { CartIcon } from 'assets/icons';

interface IProps {
  onSuccess: () => void;
  positions: IPostCartPositionsRequest['positions'];
}

const AddPositionsToCartSelect: FC<IProps> = ({ positions, onSuccess }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { currentCartId } = useSelector((state) => state.cart);
  const [showConfirm, setShowConfirm] = useState(false);
  const { refetch: refetchCartsData } = useGetCartsAll();
  const { refetch: refetchCarts } = useGetCartsAll({ enabled: false });
  const { mutate: createCart, isLoading: isCreateCartLoading } = usePostCart({
    onSuccess: async () => {
      await refetchCarts();
    }
  });
  const { mutate: addProductsToCart, isLoading: isAddProductsToCartLoading } =
    usePostCartAddProductToCart({
      onSuccess: () => {
        setShowConfirm(false);
        refetchCartsData();
        onSuccess();
      }
    });

  const handleAddToCart = () => {
    if (currentCartId) {
      addProductsToCart({
        cart_id: currentCartId,
        products: positions
      });
    } else {
      createCart(
        { symbol: t('Mój koszyk') },
        {
          onSuccess: ({ data: { id: newCartId } }) => {
            dispatch(reduxActions.setCurrentCartId(newCartId));
            refetchCarts();
            addProductsToCart({
              cart_id: newCartId,
              products: positions
            });
          }
        }
      );
    }
  };

  const disabled = positions.length < 1;
  const isAdding = isCreateCartLoading || isAddProductsToCartLoading;

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Containers-AddPositionsToCartSelect'
      )}>
      <button
        type="button"
        className={styles.addButton}
        disabled={disabled}
        onClick={() => setShowConfirm(true)}>
        <span className={styles.placeholder}>
          <CartIcon /> <Trans>Dodaj do koszyka</Trans>
        </span>
      </button>
      {showConfirm && (
        <Modal title={t('Potwierdzenie dodania')} onClose={() => setShowConfirm(false)}>
          <div className={styles.confirmationModal}>
            <Trans>Czy napewno dodać wybrane produkty do koszyka?</Trans>
            <div className={styles.confirmationModalActions}>
              <Button onClick={() => setShowConfirm(false)} ghost color="secondary">
                <Trans>Anuluj</Trans>
              </Button>
              <Button
                onClick={handleAddToCart}
                color="secondary"
                loading={isAdding}>
                <Trans>Dodaj</Trans>
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default AddPositionsToCartSelect;
